import React from 'react';

import { getSentryGlobalScope } from '@gitbook/util-debug';

/**
 * Set properties on the Sentry context.
 * These can be accessed when viewing the error in Sentry.
 */
export function useSetSentryContext(
    contexts: {
        [contextName: string]: Record<string, unknown> | null;
    },
    deps: React.DependencyList
) {
    React.useEffect(() => {
        const scope = getSentryGlobalScope();
        for (const [contextName, contextValue] of Object.entries(contexts)) {
            scope.setContext(contextName, contextValue);
        }

        return () => {
            for (const contextName of Object.keys(contexts)) {
                scope.setContext(contextName, null);
            }
        };
    }, deps);
}
